import type { CommandServices } from '@wix/cli-command-contract';
import { createCommand, Option } from '@commander-js/extra-typings';
import { NO_TTY_JSON_OUTPUT_OPTION } from '@wix/cli-command-contract';
import {
  collectTld,
  validateLimit,
  validateQuery,
} from '../domain/validations.js';

export const domainSuggest = (
  services: CommandServices,
  cliVersion: string
) => {
  return createCommand('suggest')
    .description(
      'Suggest available domains based on a keyword, brand, or business idea'
    )
    .argument(
      '<query>',
      'Keyword, brand, or business idea to base suggestions on',
      validateQuery
    )
    .option(
      '-l, --limit <number>',
      'Number of suggestions to return (1-20)',
      validateLimit
    )
    .option(
      '-t, --tld <tld...>',
      'Filter by up to 10 TLDs, without the dot (for example, com net)',
      collectTld
    )
    .addOption(new Option(NO_TTY_JSON_OUTPUT_OPTION, 'Output in JSON format'))
    .addHelpText(
      'after',
      [
        '',
        'Examples:',
        '  $ wix account domain suggest "coffee shop"',
        '  $ wix account domain suggest coffee --limit 5 --tld com io',
        '  $ wix account domain suggest coffee --json',
      ].join('\n')
    )
    .action(async (query, options, command) => {
      const { runCommand } = await import('../run-command.js');
      const { runSuggestDomains } = await import(
        '../domain/suggest-domains.js'
      );

      await runCommand(command, services, cliVersion, () =>
        runSuggestDomains({
          json: options.json,
          limit: options.limit,
          query,
          tlds: options.tld,
        })
      );
    });
};
